import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { useReplaceContent } from './useReplaceContent';

export const useHandleSelectedFile = () => {
  const { isFullHtmlDoc, htmlEditorRef, loadHtmlFileInputRef } = useWYSIWYGContext();
  const replaceContent = useReplaceContent();

  return (htmlFile: File) => {
    const fileReader = new FileReader();

    fileReader.onload = () => {
      if (typeof fileReader.result === 'string') {
        // Replaces all content (see note on the renderTiny useEffect in 'src/modules/wysiwygEditor/hooks/useRenderTinyEffect')
        if (isFullHtmlDoc) replaceContent(fileReader.result);
        else htmlEditorRef.current?.setContent(fileReader.result);
      }
      // reset the file input
      // resolves edge case where the user may want to reload the same file more than once in succession.
      // (if the value is not cleared, the onChange event will not fire)
      if (loadHtmlFileInputRef.current) loadHtmlFileInputRef.current.setAttribute('value', '');
    };
    fileReader.readAsText(htmlFile);
  };
};
